<input [id]="id" [ngClass]="[name, class]" type="text"/>
<label [for]="id">{{ 'Periodo' | translate }}</label>
